<template>
  <v-app id="app" light :class="{ online }">
<!--     <header>
      <span>Weview</span>
    </header> -->


    <main>
      <router-link to="/" class="home-link">
        <img src="./assets/weview_rond.png" alt="Vue.js PWA">
      </router-link>
      <router-view></router-view>
    </main>
  </v-app>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: `app`,
  data () {
    return {
      drawer: null,
      items: [
        { title: 'Home', icon: 'dashboard' },
        { title: 'About', icon: 'question_answer' }
      ],
      mini: false,
      right: null,
    };
  },
  methods: {
    init () {
      return this.$store.dispatch(`init`);
    },
  },
  computed: mapState([`online`]),
  mounted () {
    return this.init();
  },
};
</script>

<style type="text/css" src="../node_modules/vuetify/dist/vuetify.min.css"></style>

<style>
  body {
    margin: 0;
  }

  #app {
    font-family: 'robotoregular', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    padding-top: 30px;
    backface-visibility: inherit;
    -webkit-backface-visibility: inherit;
  }

  main {
    text-align: center;
  }

  main > .home-link {
    display: block;
    padding-top: 4rem;
  }

  header {
    margin: 0;
    height: 56px;
    padding: 0 16px 0 24px;
    background-color: #35495E;
    color: #ffffff;
  }

  header span {
    display: block;
    position: relative;
    font-size: 20px;
    line-height: 1;
    letter-spacing: .02em;
    font-weight: 400;
    box-sizing: border-box;
    padding-top: 16px;
  }

  #update-alert {
    display: none;
    text-align: center;
    background: orange;
    color: white;
    padding: 1rem;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 4;
    font-size: 1rem;
  }

  #update-alert a:visited,
  #update-alert a:hover,
  #update-alert a {
    color: white;
    text-decoration: none;
  }

  .update-available #app.online #update-alert {
    display: block;
  }

  .update-available #app.online main {
    margin-top: 3rem;
  }
</style>

<style type="text/css">
@media (max-width: 780px) {
  body {
    overflow-y: initial !important;
  }
}
</style>



// WEBPACK FOOTER //
// App.vue?dccfd802